import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "DressingListPage" */
	'pages/vehicle/Dressing/DressingListPage'));

export default [{ component, exact: true, path: '/dressings' }];